import { Slide } from '@/components/core/Slide';
import videoFile from './13-eva.webm';

export const slide = () => {
  return (
    <Slide
      notes="EVA video demonstration"
      transition="fade"
      background={{
        video: videoFile,
      }}
    >
      <div className="relative z-10 flex items-center justify-center h-full">
        <h1 className="text-8xl font-light text-white tracking-wider">EVA</h1>
      </div>
    </Slide>
  );
};
